<template>
  <div>
    <!-- Error -->
    <div v-if="('general' in errors)" class="mb-md">
      <p class="has-text-danger">{{ errors.general }}</p>
    </div>
    <div class="mb-lg">
      <PaymentTerms :preferences="preferences" v-model="selectedOption"/>
    </div>
    <!-- Navigate -->
    <div class="py-lg">
      <div class="columns">
        <div class="column">
          <b-button
            type="is-light rounded-lg"
            expanded
            @click="goBack"
            size="is-medium"
            ><b-icon icon="arrow-left"></b-icon>
          </b-button>
        </div>
        <div class="column">
          <b-button
            type="is-primary rounded-lg"
            expanded
            :disabled="!ready"
            :loading="saving"
            size="is-medium"
            @click="goForward"
          >Continue</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PaymentTerms from '@/components/Models/Preferences/PaymentTerms'
export default {
  components: {
    PaymentTerms
  },
  computed: {
    ...mapGetters(['app', 'context']),
    endpoint () {
      return this.context.route + '/retailer-preferences/'
    },
    ready () {
      return (
        this.selectedOption !== null &&
        this.selectedOption.option !== null
      )
    }
  },
  data () {
    return {
      setupIsCompleted: false,
      selectedOption: null,
      saving: false,
      errors: {}
    }
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'retailer.onboarding.fulfillment' })
    },
    goForward () {
      this.saving = true
      this.$http.post(this.endpoint, this.selectedOption).then(response => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Preferences updated!' })
        this.updateTask()
      }).catch(error => {
        if (error.response && error.response.status === 400) {
          this.errors = error.response.data
        }
        this.$buefy.toast.open({ type: 'is-danger', message: 'Please review your input and try again.' })
      }).finally(() => {
        this.saving = false
      })
    },
    updateTask () {
      const taskBody = (typeof this.task.info === 'object') ? { info: this.task.info } : { info: {} }
      taskBody.info.payment = true
      this.$emit('task:updated', taskBody, 'retailer.onboarding.import-method')
    }
  },
  mounted () {
    if (this.task && this.task.info && this.task.info.payment) {
      this.setupIsCompleted = true
    }
  },
  props: {
    task: {
      type: Object,
      require: true
    },
    preferences: {
      type: Array,
      required: true
    }
  }
}
</script>
